import {
  Flex,
  Box,
  Image,
  Text,
  Spinner,
  HStack,
  SkeletonText,
  Icon,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import Logo from "../../../assets/logo.png";
import student from "../../../assets/icons/student.svg";
import groups from "../../../assets/icons/groups.svg";
import list from "../../../assets/icons/list.svg";
import videos from "../../../assets/icons/videos.svg";
import events from "../../../assets/icons/events.svg";
import exams from "../../../assets/icons/exams.svg";
import questions from "../../../assets/icons/questions.svg";
import payment from "../../../assets/icons/events.svg";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { RiFile2Fill, RiMegaphoneFill } from "react-icons/ri";
const SuperAdminSidenavbar = () => {
  const isLoading = useSelector((state) => state.user.isLoading);

  let navTabs = [
    { label: "الطلاب", link: "/dashboard/students", icon: student },
    { label: "المجموعات", link: "/dashboard/groups", icon: groups },
    { label: "السناتر", link: "/dashboard/lectures", icon: events },
    { label: "المحتوى", link: "/dashboard/lessons", icon: list },
    { label: "امتحانات الطلاب", link: "/dashboard/student-exams", icon: exams },
    { label: "امتحانات الطلاب الرئيسية", link: "/dashboard/student_exams_main", icon: exams },
    { label: "الفيديوهات", link: "/dashboard/videos", icon: videos },
    { label: "المشاهدات", link: "/super-admin/dashboard/views", icon: videos },
    { label: "الأحداث", link: "/dashboard/events", icon: events },
    { label: "الفصول", link: "/dashboard/chapters", icon: list },
    {
      label: "حافظة الاسئلة",
      link: "/dashboard/questions-wallet",
      icon: questions,
    },
    { label: "الامتحانات", link: "/dashboard/exams", icon: exams },
    {
      label: "بنك الاسئلة",
      link: "/dashboard/questions-bank",
      icon: questions,
    },
    {
      label: "طلبات اعادة الاختبارات ",
      link: "/dashboard/exam-redo-requests",
      icon: questions,
    },
    {
      label: "الرسائل المخصصة",
      link: "/dashboard/bulk-custom-message",
      icon: RiFile2Fill,
    },
    {
      label: "الرسائل المحفوظة",
      link: "/dashboard/saved-messages",
      icon: RiFile2Fill,
    },
    {
      label: "الرسائل المحفوظة بالهاتف",
      link: "/dashboard/saved-messages-by-phone",
      icon: RiFile2Fill,
    },
    {
      label: "مدفوعات الطلاب",
      link: "/dashboard/student-payments",
      icon: payment,
    },
    {
      label: "الإعلانات",
      link: "/dashboard/announcements",
      icon: RiMegaphoneFill,
    },
    {
      label: "إشعار تدريب مخصص",
      link: "/dashboard/custom-notify-practice",
      icon: RiMegaphoneFill,
    },
  ];

  let reportsTabs = [
    {
      label: "    تقرير المجموعات",
      link: "/dashboard/groups-report",
      icon: RiFile2Fill,
    },
    {
      label: "تقرير الغياب",
      link: "/dashboard/absent-report",
      icon: RiFile2Fill,
    },
    {
      label: "الحضور",
      link: "/dashboard/attendence-report",
      icon: RiFile2Fill,
    },
    {
      label: "غياب الامتحانات",
      link: "/dashboard/exam-attendence-report",
      icon: RiFile2Fill,
    },
    {
      label: "تقرير الامتحانات",
      link: "/dashboard/exam-report",
      icon: RiFile2Fill,
    },
    {
      label: "تقرير مشاهدات الفيديوهات",
      link: "/dashboard/videos-report",
      icon: RiFile2Fill,
    },
    {
      label: "تقرير طباعة الاسئلة",
      link: "/dashboard/print-all-questions",
      icon: RiFile2Fill,
    },
    {
      label: "تقرير عدم الدفع",
      link: "/dashboard/unpaid-report",
      icon: RiFile2Fill,
    },
    {
      label: "تقرير الدفع",
      link: "/dashboard/payment-report",
      icon: RiFile2Fill,
    },
    {
      label: "المستخدمون النشطون في التليجرام",
      link: "/dashboard/telegram-active-users",
      icon: RiFile2Fill,
    },
    {
      label: "المستخدمون غير النشطين في التليجرام",
      link: "/dashboard/telegram-inactive-users",
      icon: RiFile2Fill,
    },
  ];
  return (
    <Flex
      w={{ base: "100%", lg: "20%" }}
      h={{ base: "auto", lg: "100vh" }}
      flexDirection={"column"}
      zIndex="100"
      position={{ base: "relative", lg: "fixed" }}
      bg={{ base: "white", md: "#f5f5f5" }}
      px={{ base: "10px", lg: "20px" }}
      borderLeft={{ base: "none", lg: "1px solid #45424226" }}
      borderBottom={{ base: "1px solid #45424226", lg: "none" }}
      alignItems={{ base: "center", lg: "flex-start" }}
      className="scroll"
      overflowY={{ base: "visible", lg: "auto" }}
      maxH={{ base: "none", lg: "100vh" }}
    >
      <Image
        alignSelf="center"
        my={{ base: "10px", lg: "-80px" }}
        w={{ base: "150px", lg: "100%" }}
        maxW={{ base: "200px", lg: "100%" }}
        loading="lazy"
        src={Logo}
        alt="asquera"
        onClick={() => window.location.replace("/")}
        cursor="pointer"
      />

      {isLoading ? (
        <HStack w="100%" bg="transparent" h="100%">
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={7}
            spacing="20"
          />
        </HStack>
      ) : (
        <Accordion defaultIndex={[0]} allowMultiple w="100%">
          <AccordionItem w="100%" border="0">
            <h2>
              <AccordionButton
                justifyContent="space-between"
                w="100%"
                fontSize="22px"
                color="main_1"
                _expanded={{ color: "white", bg: "main_1" }}
                _focus={{ outline: "none" }}
              >
                <Box display={{ base: "block", lg: "block" }} fontSize={{ base: "18px", lg: "22px" }}>
                  محتوي المعلمين
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              {navTabs?.map((data, index) => {
                return (
                  <Link to={data.link} key={index} style={{ width: "90%" }}>
                    <Flex
                      w="100%"
                      color="black"
                      alignItems="center"
                      justifyContent={{ base: "center", lg: "flex-start" }}
                      mt="10px"
                      p={{ base: "0", lg: "25px" }}
                      cursor={"pointer"}
                      h={{ base: "60px", lg: "" }}
                      bg={
                        window.location.pathname == data.link
                          ? "#e4e4e4"
                          : "transparent"
                      }
                      borderRadius="15px"
                      fontWeight={
                        window.location.pathname == data.link ? "600" : "500"
                      }
                      _hover={{
                        bg: "#e4e4e4",
                        fontWeight: "600",
                      }}
                    >
                      {typeof data?.icon === 'string' ? (
                        <Image src={data?.icon} w="30px" />
                      ) : (
                        <Icon as={data?.icon} fontSize="22px" color="main_1" />
                      )}
                      <Text
                        fontSize={{ base: "16px", lg: "20px" }}
                        mx="20px"
                        mt="2px"
                        display={{ base: "block", lg: "block" }}
                        color="main_1"
                      >
                        {data.label}
                      </Text>
                    </Flex>
                  </Link>
                );
              })}
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem w="100%" border="0" mt="60px">
            <h2>
              <AccordionButton
                justifyContent="space-between"
                w="100%"
                color="main_1"
                fontSize="22px"
                _expanded={{ color: "white", bg: "main_1" }}
                _focus={{ outline: "none" }}
              >
                <Box display={{ base: "block", lg: "block" }} fontSize={{ base: "18px", lg: "22px" }}>التقارير</Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              {reportsTabs?.map((data, index) => {
                return (
                  <Link key={index} to={data?.link} style={{ width: "90%" }}>
                    <Flex
                      w="100%"
                      color="black"
                      alignItems="center"
                      justifyContent={{ base: "center", lg: "flex-start" }}
                      mt="10px"
                      p={{ base: "0", lg: "25px" }}
                      cursor={"pointer"}
                      h={{ base: "60px", lg: "" }}
                      bg={
                        window.location.pathname == data?.link
                          ? "#e4e4e4"
                          : "transparent"
                      }
                      borderRadius="15px"
                      fontWeight={
                        window.location.pathname == data?.link ? "600" : "500"
                      }
                      _hover={{
                        bg: "#e4e4e4",
                        fontWeight: "600",
                      }}
                    >
                      <Icon as={data?.icon} fontSize="22px" color="main_1" />

                      <Text
                        fontSize={{ base: "14px", lg: "14px" }}
                        mx="20px"
                        mt="2px"
                        display={{ base: "block", lg: "block" }}
                        color="main_1"
                      >
                        {data?.label}
                      </Text>
                    </Flex>
                  </Link>
                );
              })}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
    </Flex>
  );
};

export default SuperAdminSidenavbar;
